/**
 * Central allow-list of project codes that have Device Defender enabled.
 *
 * Single source of truth for Device Defender project gating. Add a project
 * code here to enable the Defender status badge, block/unblock actions and the
 * blocked-devices list for that project.
 *
 * Current projects:
 * - 23 & 36: Purina
 * - 28: Vertuo
 * - 34: VertuoMini
 * - 99: (other brand)
 */
export const DEFENDER_ENABLED_PROJECT_CODES = [23, 28, 34, 36, 99];

/**
 * Returns true when the given project code has Device Defender enabled.
 * Accepts number or string codes.
 * @param {number|string} projectCode
 * @returns {boolean}
 */
export const isDefenderEnabledProject = (projectCode) => DEFENDER_ENABLED_PROJECT_CODES.includes(Number(projectCode));
